import { useTranslation } from "react-i18next";
import { Divider, Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";

import type { LocationDetailFormPayload } from "modules/LocationOverviewDashboard/hooks";

const FormHelper = createFormHelper<LocationDetailFormPayload>();

type DmsSystemProps = {
  tabId: string;
};

export const DmsSystem = ({ tabId }: DmsSystemProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="location-overview-section">
      <div className="section-title">
        <div>
          <Icon className="cloud" />
        </div>
        <span className="section-title-text">{t("v8_dms_system", "DMS / System")}</span>
      </div>

      <div className="location-overview-subheading">{t("v8_dms_settings", "DMS Settings")}</div>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_data_source", "Data source")}</label>
          <FormHelper.Field.Input name="dms_location_source" />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={16}>
          <FormHelper.Field.Checkbox name="can_add_intervention_elements" label={t("v8_add_intervention_subitems", "Add Intervention subitems")} />
        </Form.Field>
      </Form.Group>
      <Divider />

      <div className="location-overview-subheading">{t("v8_lease", "Lease")}</div>
      <Form.Group>
        <Form.Field width={16}>
          <FormHelper.Field.Checkbox
            name="default_customer_ok_for_dms_lease_intervention"
            label={t("v8_customer_ok_by_default_for_dms_lease_interventions", "Customer OK by Default for DMS Lease Interventions")}
          />
        </Form.Field>
      </Form.Group>
    </Element>
  );
};
